var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.71429 0C3.46444 0.00147449 2.2662 0.49863 1.38242 1.38241C0.498635 2.26619 0.0014795 3.46443 5.01552e-06 4.71429C-0.00149194 5.73567 0.332139 6.72933 0.949719 7.54286C0.949719 7.54286 1.07829 7.71214 1.09929 7.73657L4.71429 12L8.33101 7.73443C8.34986 7.71171 8.47886 7.54286 8.47886 7.54286L8.47929 7.54157C9.09656 6.72841 9.43004 5.7352 9.42858 4.71429C9.4271 3.46443 8.92995 2.26619 8.04617 1.38241C7.16238 0.49863 5.96414 0.00147449 4.71429 0ZM4.71429 6.42857C4.37524 6.42857 4.0438 6.32803 3.76188 6.13966C3.47997 5.95129 3.26025 5.68356 3.1305 5.37031C3.00075 5.05707 2.9668 4.71238 3.03294 4.37985C3.09909 4.04731 3.26236 3.74185 3.50211 3.5021C3.74185 3.26236 4.04731 3.09909 4.37985 3.03294C4.71239 2.96679 5.05707 3.00074 5.37032 3.13049C5.68356 3.26024 5.9513 3.47997 6.13967 3.76188C6.32804 4.04379 6.42858 4.37523 6.42858 4.71429C6.42801 5.16877 6.24722 5.60447 5.92585 5.92584C5.60448 6.24721 5.16877 6.428 4.71429 6.42857Z",
    fill: "#808795"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/LocationIcon.1b867555702a9dab5d9f21e3ac05a284.svg";
export { ForwardRef as ReactComponent };